import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api_middleware";

export interface ExperienceEntry {
  title: string;
  subtitle: string | null;
  res_link_params_id: string;
}

// Fetch all selector experiences (admin only, cross-org)
export const fetchAllSelectorExperiences = createAsyncThunk(
  "selectorExperiences/fetchAllSelectorExperiences",
  async () => {
    const response = await api(`v1/admin/selector-experiences/`, "GET");
    return response;
  }
);

// Fetch selector experiences for a specific organization
export const fetchSelectorExperiencesForOrganization = createAsyncThunk(
  "selectorExperiences/fetchSelectorExperiencesForOrganization",
  async (organizationId: string) => {
    const response = await api(
      `v1/admin/organizations/${organizationId}/selector-experiences/`,
      "GET"
    );
    return response;
  }
);

// Fetch a single selector experience by ID
export const fetchSelectorExperience = createAsyncThunk(
  "selectorExperiences/fetchSelectorExperience",
  async ({ organizationId, selectorId }: { organizationId: string; selectorId: string }) => {
    const response = await api(
      `v1/admin/organizations/${organizationId}/selector-experiences/${selectorId}`,
      "GET"
    );
    return response;
  }
);

// Create a new selector experience
export interface CreateSelectorExperienceParams {
  organization_id: string;
  id: string;
  pre_selection_copy?: string | null;
  selector_title?: string | null;
  selector_subtitle?: string | null;
  sub_client_mode_enabled?: boolean;
  entries: ExperienceEntry[];
}

export const createSelectorExperience = createAsyncThunk(
  "selectorExperiences/createSelectorExperience",
  async (params: CreateSelectorExperienceParams) => {
    const { organization_id, ...data } = params;
    const response = await api(
      `v1/admin/organizations/${organization_id}/selector-experiences/`,
      "POST",
      data
    );
    return response;
  }
);

// Update a selector experience
export interface UpdateSelectorExperienceParams {
  organization_id: string;
  selector_id: string;
  pre_selection_copy?: string | null;
  selector_title?: string | null;
  selector_subtitle?: string | null;
  sub_client_mode_enabled?: boolean;
  entries?: ExperienceEntry[];
}

export const updateSelectorExperience = createAsyncThunk(
  "selectorExperiences/updateSelectorExperience",
  async (params: UpdateSelectorExperienceParams) => {
    const { organization_id, selector_id, ...updateData } = params;
    const response = await api(
      `v1/admin/organizations/${organization_id}/selector-experiences/${selector_id}`,
      "PUT",
      updateData
    );
    return response;
  }
);

// Delete a selector experience
export const deleteSelectorExperience = createAsyncThunk(
  "selectorExperiences/deleteSelectorExperience",
  async ({ organizationId, selectorId }: { organizationId: string; selectorId: string }) => {
    await api(
      `v1/admin/organizations/${organizationId}/selector-experiences/${selectorId}`,
      "DELETE"
    );
    return selectorId;
  }
);

// Fetch ResLinks for an organization (for picker)
// Using the same interface as AssessmentLink from assessmentActions
export const fetchOrganizationResLinks = createAsyncThunk(
  "selectorExperiences/fetchOrganizationResLinks",
  async (organizationId: string) => {
    const response = await api(
      `v1/admin/organizations/${organizationId}/assessment-links`,
      "GET"
    );
    return response;
  }
);
